import './DAcLogin.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import DacLoginForm from '../DAcCreateAccount/components/DacLoginForm';
var DAcLogin = function DAcLogin(props) {
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var fields = props.fields,
    params = props.params;
  var _fields$data = fields.data,
    configuration = _fields$data.configuration,
    dictionary = _fields$data.dictionary,
    settings = _fields$data.settings;
  var apiKey = get(settings, 'apiKey.jss.value');
  var apiUrl = get(settings, 'apiUrl.jss.value');
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "dac-login"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "dac-login__title"
  }, get(configuration, 'loginTitle.jss.value')), /*#__PURE__*/React.createElement("p", {
    className: "dac-login__description"
  }, get(configuration, 'loginDescription.jss.value')), /*#__PURE__*/React.createElement("div", {
    className: "dac-login__form-wrap"
  }, /*#__PURE__*/React.createElement(DacLoginForm, {
    dictionary: dictionary,
    isLoginComponent: true,
    configuration: configuration,
    apiConfig: {
      apiKey: apiKey,
      apiUrl: apiUrl
    }
  }))));
};
var StyledWrapper = function StyledWrapper(_ref) {
  var children = _ref.children,
    rtl = _ref.rtl,
    anchorUrlParameter = _ref.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
export default DAcLogin;
var commonStyles = "c14id13o";
var ltrStyles = "l1ned55i";
var rtlStyles = "rrws79b";